import mediaQueries from "syf-component-library/const/mediaQueries";
import useMedia from "syf-js-utilities/hooks/useMedia";
var useIsTablet = function () {
    return useMedia([mediaQueries.greaterThanMedium], [true], false);
};
export default useIsTablet;
